import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedBadges from './CustomizedBadges';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedBadges, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/badges/demos/customized/CustomizedBadges.tsx",
    "fileName": "CustomizedBadges.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Badge from '@mui/material/Badge';\nimport Avatar from '@mui/material/Avatar';\nimport List from '@mui/material/List';\nimport ListItemAvatar from '@mui/material/ListItemAvatar';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport Paper from '@mui/material/Paper';\nimport { styled } from '@mui/material/styles';\n\ntype ContactStatus = 'online' | 'offline';\n\nconst statusLabels: Record<ContactStatus, string> = {\n  online: 'Online',\n  offline: 'Offline',\n};\n\nconst contacts = [\n  { name: 'Remy Sharp', initials: 'R', status: 'online' },\n  { name: 'Travis Howard', initials: 'T', status: 'offline' },\n  { name: 'Cindy Baker', initials: 'C', status: 'online' },\n] as const;\n\nconst ContactStatusBadge = styled(Badge, {\n  shouldForwardProp: (prop) => prop !== 'status',\n})<{ status: ContactStatus }>(({ theme, status }) => {\n  const themePalette = (theme.vars ?? theme).palette;\n  const offlineBadgeColor = theme.vars\n    ? theme.vars.palette.Avatar.defaultBg\n    : theme.palette.grey[400];\n\n  return {\n    '& .MuiBadge-badge': {\n      height: 10,\n      minWidth: 10,\n      border: `1px solid ${themePalette.grey[300]}`,\n      boxShadow: `0 0 0 2px ${themePalette.background.paper}`,\n      ...(status === 'offline' && {\n        backgroundColor: offlineBadgeColor,\n        ...(theme.vars\n          ? {}\n          : theme.applyStyles('dark', {\n              backgroundColor: theme.palette.grey[600],\n            })),\n      }),\n    },\n  };\n});\n\nexport default function CustomizedBadges() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Paper variant=\"outlined\" sx={{ width: 320, maxWidth: '100%' }}>\n      <List component=\"nav\" aria-label=\"contacts\" sx={{ py: 0 }}>\n        {contacts.map((contact) => {\n          const statusLabel = statusLabels[contact.status];\n\n          return (\n            <ListItemButton\n              key={contact.name}\n              aria-label={`${contact.name}, ${contact.status}`}\n            >\n              <ListItemAvatar>\n                <ContactStatusBadge\n                  status={contact.status}\n                  color={contact.status === 'online' ? 'success' : 'default'}\n                  variant=\"dot\"\n                  overlap=\"circular\"\n                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n                >\n                  <Avatar>{contact.initials}</Avatar>\n                </ContactStatusBadge>\n              </ListItemAvatar>\n              <ListItemText primary={contact.name} secondary={statusLabel} />\n            </ListItemButton>\n          );\n        })}\n      </List>\n    </Paper>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 79,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Badge from '@mui/material/Badge';\nimport Avatar from '@mui/material/Avatar';\nimport List from '@mui/material/List';\nimport ListItemAvatar from '@mui/material/ListItemAvatar';\nimport ListItemButton from '@mui/material/ListItemButton';\nimport ListItemText from '@mui/material/ListItemText';\nimport Paper from '@mui/material/Paper';\nimport { styled } from '@mui/material/styles';\n\ntype ContactStatus = 'online' | 'offline';\n\nconst statusLabels: Record<ContactStatus, string> = {\n  online: 'Online',\n  offline: 'Offline',\n};\n\nconst contacts = [\n  { name: 'Remy Sharp', initials: 'R', status: 'online' },\n  { name: 'Travis Howard', initials: 'T', status: 'offline' },\n  { name: 'Cindy Baker', initials: 'C', status: 'online' },\n] as const;\n\nconst ContactStatusBadge = styled(Badge, {\n  shouldForwardProp: (prop) => prop !== 'status',\n})<{ status: ContactStatus }>(({ theme, status }) => {\n  const themePalette = (theme.vars ?? theme).palette;\n  const offlineBadgeColor = theme.vars\n    ? theme.vars.palette.Avatar.defaultBg\n    : theme.palette.grey[400];\n\n  return {\n    '& .MuiBadge-badge': {\n      height: 10,\n      minWidth: 10,\n      border: `1px solid ${themePalette.grey[300]}`,\n      boxShadow: `0 0 0 2px ${themePalette.background.paper}`,\n      ...(status === 'offline' && {\n        backgroundColor: offlineBadgeColor,\n        ...(theme.vars\n          ? {}\n          : theme.applyStyles('dark', {\n              backgroundColor: theme.palette.grey[600],\n            })),\n      }),\n    },\n  };\n});\n\nexport default function CustomizedBadges() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "    <Paper variant=\"outlined\" sx={{ width: 320, maxWidth: '100%' }}>\n      <List component=\"nav\" aria-label=\"contacts\" sx={{ py: 0 }}>\n        {contacts.map((contact) => {\n          const statusLabel = statusLabels[contact.status];\n\n          return (\n            <ListItemButton\n              key={contact.name}\n              aria-label={`${contact.name}, ${contact.status}`}\n            >\n              <ListItemAvatar>\n                <ContactStatusBadge\n                  status={contact.status}\n                  color={contact.status === 'online' ? 'success' : 'default'}\n                  variant=\"dot\"\n                  overlap=\"circular\"\n                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}\n                >\n                  <Avatar>{contact.initials}</Avatar>\n                </ContactStatusBadge>\n              </ListItemAvatar>\n              <ListItemText primary={contact.name} secondary={statusLabel} />\n            </ListItemButton>\n          );\n        })}\n      </List>\n    </Paper>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 79,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Badge",
      "@mui/material/Avatar",
      "@mui/material/List",
      "@mui/material/ListItemAvatar",
      "@mui/material/ListItemButton",
      "@mui/material/ListItemText",
      "@mui/material/Paper",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
